import { type MapDef, type MapSource, parseMap } from './map';
import { BRAMBLEWICK } from './maps/bramblewick';
import { PROVING_GROUND } from './maps/proving-ground';
import { RANGE_MAP } from './maps/range';
import { TRAINING_GARDEN } from './maps/training-garden';
import { TWIN_HOLLOWS } from './maps/twin-hollows';
import { VILLAGE } from './maps/village';
import { WILLOW_BEND } from './maps/willow-bend';
import { ZOMBIE_FARM } from './maps/zombie-farm';

export * from './achievements';
export * from './air';
export * from './bots';
export * from './cars';
export * from './characters';
export * from './config';
export * from './creeps';
export * from './economy';
export * from './fishing';
export * from './furniture';
export * from './gun-skins';
export * from './hash';
export * from './hats';
export * from './heads';
export * from './looks';
export * from './map';
export * from './minions';
export * from './moderation';
export * from './modes';
export * from './online';
export * from './program';
export * from './regions';
export * from './royale';
export * from './scenes';
export * from './season';
export * from './store';
export * from './targets';
export * from './teams';
export * from './things';
export * from './vision';
export * from './weapons';
export * from './weekly';
export * from './zombies';

const MAP_SOURCES: readonly MapSource[] = [
  TRAINING_GARDEN,
  RANGE_MAP,
  ZOMBIE_FARM,
  WILLOW_BEND,
  TWIN_HOLLOWS,
  BRAMBLEWICK,
  VILLAGE,
  PROVING_GROUND,
];
const parsed = new Map<string, MapDef>();

function sourceOf(id: string): MapSource {
  const src = MAP_SOURCES.find((m) => m.id === id);
  if (!src) throw new Error(`Unknown map '${id}'`);
  return src;
}

/** The map `id`, parsed once (treat it as immutable: every world in the thread shares it). */
export function getMap(id: string): MapDef {
  let map = parsed.get(id);
  if (map) return map;
  map = parseMap(sourceOf(id));
  parsed.set(id, map);
  return map;
}

/** The map `id`'s name, never parsed for it: the menus name maps they don't draw (ADR-0217). */
export const mapName = (id: string): string => sourceOf(id).name;

export const MAP_IDS = MAP_SOURCES.map((m) => m.id);
